import React from "react";
import { User, Calendar, Wallet } from "lucide-react";
import moment from "moment";

function EventosCard({ evento, onSelectEvento }) {
  return (
    <div
      onClick={onSelectEvento}
      className="cursor-pointer rounded-lg border border-gray-300 bg-white p-4 shadow-md hover:shadow-lg transition-shadow"
    >
      <img
        src={evento.foto}
        alt={evento.titulo}
        className="h-48 w-full rounded-md object-cover mb-3"
      />
      <h3 className="text-center font-bold text-lg mb-1">{evento.titulo}</h3>
      <p className="underline font-semibold mb-2 text-center">Informações</p>
      <div className="space-y-1">
        <div className="flex items-center gap-2 text-gray-700">
          <Calendar size={18} />
          <span>Data: {moment(evento.data).format("DD/MM/YYYY")}</span>
        </div>
        <div className="flex items-center gap-2 text-gray-700">
          <Wallet size={18} />
          <span>Investimento: R${evento.preco.toFixed(2)}</span>
        </div>
        <div className="flex items-center gap-2 text-gray-700">
          <User size={18} />
          <span>Responsável: {evento.responsavel}</span>
        </div>
      </div>
    </div>
  );
}

export default EventosCard;
